// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Bell(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Bell" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M18.5 15V10.5C18.5 7.19683 16.7174 4.73165 13.4999 4V2H10.4999V4C7.27119 4.73165 5.5 7.18607 5.5 10.5V15L3.5 17V18H20.5V17L18.5 15Z", fill: "currentColor" }),
            React.createElement("path", { d: "M14.4999 19.5C14.4999 20.875 13.4142 22 11.9999 22C10.5728 22 9.49994 20.875 9.49994 19.5H14.4999Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Bell.js.map